import { Outlet } from 'react-router-dom'

const PagesLayout = () => <Outlet />

export default PagesLayout
